export default function numberFormat (number: number) {
  return number?number.toLocaleString():'0';
}